export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./InstrumentacionDidacticaPage.vue?vue&type=template&id=605ca531&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/InstrumentacionDidacticaPage.vue?vue&type=template&id=605ca531&scoped=true&
// module id = 611
// module chunks = 25